import { useState } from "react";
import TransferRequestsSection from "./TransferRequestsSection";
import OutgoingTransferStatus from "./OutgoingTransferStatus";
import BuildChapterManager from "./BuildChapterManager";
import CreateBuildChapterModal from "./CreateBuildChapterModal";
import ManageVehicleModal from "./ManageVehicleModal";
import TransferBuildForm from "./TransferBuildForm";
import GarageVehicleCard from "./GarageVehicleCard";

function GarageList({
  auth,
  username,
  garageCars,
  showToast,
  navigate,
  editGarageCar,
  openConfirmModal,
  removeGarageCar,
  createBuildChapter,
  switchBuildChapter,
  renameBuildChapter,
  editVehicleDetails,
  onAddVehicle
}) {
  const [chapterManagerCar, setChapterManagerCar] = useState(null);
  const [createChapterCar, setCreateChapterCar] = useState(null);
  const [manageVehicleCar, setManageVehicleCar] = useState(null);
  const [transferVehicleCar, setTransferVehicleCar] = useState(null);

  return (
    <div style={sectionContentStyle}>
      <TransferRequestsSection
        userId={auth.currentUser?.uid}
        profile={{ username, userId: auth.currentUser?.uid, garageCars }}
        showToast={showToast}
      />

      {garageCars.length > 0 ? garageCars.map((car) => (
        <div key={car.id}>
          <GarageVehicleCard
            car={car}
            username={username}
            navigate={navigate}
            onSelectPhase={() => setChapterManagerCar(car)}
            onManage={() => setManageVehicleCar(car)}
          />
          <OutgoingTransferStatus car={car} userId={auth.currentUser?.uid} showToast={showToast} />
        </div>
      )) : (
        <div style={emptyGarageStyle}>
          <h3 style={{ margin: 0 }}>Your garage is empty</h3>
          <p style={{ margin: 0, opacity: 0.75, lineHeight: 1.6 }}>Add your first vehicle to start documenting your build.</p>
          <button type="button" onClick={onAddVehicle} style={emptyAddButtonStyle}>Add Vehicle</button>
        </div>
      )}

      {chapterManagerCar && (
        <BuildChapterManager
          car={chapterManagerCar}
          onClose={() => setChapterManagerCar(null)}
          onStartNewChapter={() => setCreateChapterCar(chapterManagerCar)}
          onSwitchChapter={async (stageId) => {
            await switchBuildChapter(chapterManagerCar.id, stageId);
            setChapterManagerCar(null);
          }}
          onRenameChapter={async (stageId, newName) => {
            await renameBuildChapter(chapterManagerCar.id, stageId, newName);
            setChapterManagerCar((current) => current ? {
              ...current,
              stages: (current.stages || []).map((stage) => stage.id === stageId ? { ...stage, name: newName } : stage)
            } : current);
          }}
        />
      )}

      {createChapterCar && (
        <CreateBuildChapterModal
          isOpen
          currentPhaseName={createChapterCar.stages?.find((stage) => stage.id === createChapterCar.currentStageId)?.name || "Current Build"}
          currentStage={createChapterCar.stages?.find((stage) => stage.id === createChapterCar.currentStageId)}
          onCancel={() => setCreateChapterCar(null)}
          onCreate={async (chapterData) => {
            await createBuildChapter(createChapterCar.id, chapterData);
            setCreateChapterCar(null);
            setChapterManagerCar(null);
          }}
        />
      )}

      {manageVehicleCar && (
        <ManageVehicleModal
          isOpen
          onClose={() => setManageVehicleCar(null)}
          onEditCurrentPhase={() => {
            editGarageCar(manageVehicleCar);
            setManageVehicleCar(null);
          }}
          onVehicleInfo={() => {
            editVehicleDetails(manageVehicleCar);
            setManageVehicleCar(null);
          }}
          onTransfer={() => {
            setTransferVehicleCar(manageVehicleCar);
            setManageVehicleCar(null);
          }}
          onDelete={() => {
            const carToDelete = manageVehicleCar;
            setManageVehicleCar(null);
            openConfirmModal({
              title: "Delete Vehicle",
              message: `Are you sure you want to permanently delete "${carToDelete.name}"?\n\nThis action cannot be undone.`,
              confirmText: "Delete Vehicle",
              onConfirm: async () => await removeGarageCar(carToDelete.id)
            });
          }}
        />
      )}

      {transferVehicleCar && (
        <div style={modalOverlayStyle}>
          <div style={modalCardStyle}>
            <h2 style={{ marginTop: 0 }}>Transfer Ownership</h2>
            <TransferBuildForm
              car={transferVehicleCar}
              profile={{ username, userId: auth.currentUser?.uid }}
              showToast={showToast}
              onSent={() => setTransferVehicleCar(null)}
            />
            <button type="button" onClick={() => setTransferVehicleCar(null)} style={modalCloseButtonStyle}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

const sectionContentStyle = { display: "flex", width: "100%", maxWidth: "100%", flexDirection: "column", gap: "18px", padding: "10px 0 18px", boxSizing: "border-box" };
const emptyGarageStyle = { display: "grid", justifyItems: "center", gap: "12px", padding: "28px 18px", border: "1px solid #333", borderRadius: "16px", background: "#1b1b1b", textAlign: "center" };
const emptyAddButtonStyle = { minHeight: "46px", padding: "10px 18px", border: "1px solid #e10600", borderRadius: "11px", background: "#e10600", color: "#fff", cursor: "pointer", fontWeight: "900" };
const modalOverlayStyle = { position: "fixed", inset: 0, display: "flex", zIndex: 30000, alignItems: "center", justifyContent: "center", padding: "20px", backgroundColor: "rgba(0,0,0,0.82)" };
const modalCardStyle = { width: "100%", maxWidth: "420px", padding: "28px", border: "1px solid #333", borderRadius: "20px", backgroundColor: "#181818", color: "white", boxSizing: "border-box" };
const modalCloseButtonStyle = { width: "100%", marginTop: "12px", padding: "14px", border: "none", borderRadius: "12px", backgroundColor: "#333", color: "white", cursor: "pointer", fontWeight: "bold" };

export default GarageList;
